import React from 'react';

export const SelectOptions = (props) => {
    return typeof props.value === "undefined" ? <option value={props.fieldName}>{props.fieldName}</option> : <option value={props.value}>{props.fieldName}</option>;
}
